import { render, staticRenderFns } from "./Tourism.vue?vue&type=template&id=4ce90ae2&"
import script from "./Tourism.vue?vue&type=script&lang=js&"
export * from "./Tourism.vue?vue&type=script&lang=js&"
import style0 from "./Tourism.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports